
import { EventType } from '@azure/msal-browser';
import { useEffect, useState } from 'react'
import { useCreateDeviceRegistrationMutation, useDeleteDeviceRegistrationMutation } from '../../services/notifications/notificationsApi';
import { useFlutterAppInterface } from '../useFlutterAppInterface';
import { toaster } from 'baseui/toast';
import { msalInstance } from '../..';
import { useLazyGetUserQuery } from '../../services/msgraph/msGraphApi';

export type useDeviceRegistrationOutput = {
  doCreateDeviceReg: () => void,
}
function useDeviceRegistration() {

  const [createDeviceRegistration, createDeviceRegistrationResult] = useCreateDeviceRegistrationMutation();
  const { platformString, deviceId, deviceRegistrationToken } = useFlutterAppInterface();
  const [getUser, results] = useLazyGetUserQuery();

  // attatch to login/logout events and remember it - flutter will set its data later
  useEffect(() => {
    msalInstance.addEventCallback((event: any) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
          const account = event.payload.account;
          if (account) msalInstance.setActiveAccount(account);
        }
        doCreateDeviceReg();
      }
    });
  })

  async function doCreateDeviceReg() {
    if (!msalInstance.getActiveAccount())
      return;
    if (deviceRegistrationToken && deviceRegistrationToken.length > 5 && deviceId && platformString) {
      // conditional fetch
      const usrResult = await getUser();
      const usrLanguage = usrResult.data.preferredLanguage || navigator.language;
      console.debug("[useDeviceRegistration.ts] - new deviceRegistration", deviceId, platformString,usrLanguage)
      await createDeviceRegistration({ deviceId: deviceId, deviceRegistrationToken: deviceRegistrationToken, language: usrLanguage, platform: platformString });
    }
  }


  useEffect(() => {
    if (createDeviceRegistrationResult.isError) {
      console.error('[useDeviceRegistration.ts] - create error',JSON.stringify(createDeviceRegistrationResult.error))
      toaster.negative('Error register device.\n' + JSON.stringify(createDeviceRegistrationResult.error), {
        autoHideDuration: 5000, overrides: {
          InnerContainer: {
            style: { width: "100%" }
          }
        }
      })
    }
    else if (createDeviceRegistrationResult.isSuccess) {
      console.log('[useDeviceRegistration.ts] - Device registered for Push Notifications');
      /*toaster.info(`Device registered for Push Notifications`, {
        autoHideDuration: 5000, overrides: {
          InnerContainer: {
            style: { width: "100%" }
          }
        }
      })*/
    }
  }, [createDeviceRegistrationResult])


  return { doCreateDeviceReg: doCreateDeviceReg}
}

export default useDeviceRegistration


